<div>
  <router-outlet></router-outlet>
</div>
<app-banner [banners]="banners$ | async"></app-banner>
